module.exports = __webpack_public_path__ + "static/media/imani-clovis-89441-unsplash-min.8b1a24e2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imani-clovis-89441-unsplash-min.jpg
// module id = 108
// module chunks = 0